import React, { useState, useEffect } from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Cookies from "js-cookie";
import axios from "axios";
import styles from "../PD/pd.module.css";
import { url } from "../../../../../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from "@mui/material/Tooltip";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {useParams } from "react-router-dom";

const ImageDisplay = () => {
    const { loanid } = useParams();
    const [imageUrl, setImageUrl] = useState([]);
    const { borrowerData } = useBorrowerContext();
    const fetchedBorrowerDetails = borrowerData.borrower;
    const [open, setOpen] = React.useState(false);

    const mappedLoanId = () => {
        axios
            .post(url + "/videosdk/download/photo", {
                token: Cookies.get('Token'),
                email: Cookies.get('Email'),
                borrower_Id: fetchedBorrowerDetails.borrower_uniqueno,
                loan_Id: loanid
            })
            .then((res) => {
                if (res.data.auth === false) {
                    toast.error(res.data.message);
                    setImageUrl([]);
                } else {
                    // console.log(res.data.images);
                    setImageUrl(res.data.images);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    let downloadCount = 1;

    const downloadImage = async (key) => {
        try {
            setOpen(true);
            const response = await axios.post(url + '/videosdk/download/document', {
                token: Cookies.get('Token'),
                email: Cookies.get('Email'),
                key
            });
            const base64Data = response.data.base64;
            const extension = key.split('.').pop();
            const fileName = `image${downloadCount}.${extension}`;
            const link = document.createElement('a');
            link.href = base64Data;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            downloadCount++;
            setOpen(false);
        } catch (err) {
            setOpen(false);
            console.error('Error downloading image:', err);
        }
    };

       useEffect(() => {
          mappedLoanId();
          //eslint-disable-next-line
       }, [loanid]);

    return (
        <>
            <hr className="hori-line" />
            <div className={styles.imageContainer}>
                <div className={styles.imageDisplay}>
                    {(imageUrl && imageUrl.length > 0) ? (
                        [...imageUrl].reverse().map((img, index) => (
                            <Card key={index} sx={{ maxWidth: 335 }}>
                                <CardMedia
                                    sx={{ height: 180 }}
                                    image={img.url}
                                    title="green iguana"
                                />
                                <CardContent>
                                    <div style={{ display: "flex" }}>
                                        <div>
                                            <Typography gutterBottom variant="h8" component="div">
                                                <p><strong>Time: </strong>{img.image_time}</p>
                                                <p><strong>Date: </strong>{img.image_date}</p>
                                            </Typography>
                                            <Typography gutterBottom variant="h8" component="div">
                                                <p><strong>Nearby Location: </strong> {img.image_location}</p>
                                            </Typography>
                                        </div>
                                        <div>
                                            <Tooltip title="Download Image">
                                                <DownloadIcon style={{ color: "#034ea1", fontSize: "1.5rem" }} onClick={() => downloadImage(img.key)}>
                                                </DownloadIcon>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        ))
                    ) : (
                        <h1 style={{ textAlign: "center", width: "100%" }}>Image Not Available</h1>
                    )}
                </div>
            </div>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default ImageDisplay;









